import { createAction, createReducer } from 'redux-act';

export const openModal = createAction('OPEN_MODAL');
export const closeModal = createAction('CLOSE_MODAL');

const DEFAULT_MODAL_STATE = {
  modalType: null,
  modalProps: {
    open: false,
  }
};

export const modal = createReducer(function (on, off) {
  on(openModal, (state, payload) => {
    return {
      modalProps: {
        ...payload.modalProps,
        open: true,
      },
      modalType: payload.modalType,
    }
  });
  on(closeModal, (state, payload) => {
    return DEFAULT_MODAL_STATE;
  });

}, DEFAULT_MODAL_STATE);
